import React, {memo, Suspense} from "react"
import {formatTextTestIds} from "@next/utils"
import {TextModel} from "models/Text"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

interface MenuButtonProps {
    setOpen: (value: React.SetStateAction<boolean>) => void
    anchorRef: React.RefObject<HTMLButtonElement>
    buttonText: string
    open: boolean
    text: TextModel
    disableIcon: boolean
    templating: {mainTemplate: string; fallbackTemplate: string}
}

const MenuButton = memo((props: MenuButtonProps) => {
    const ComponentName = useTemplatedComponent(props.templating, MANIFEST)
    return (
        <Suspense>
            <ComponentName {...props} dataTestId={formatTextTestIds(`plp-menu-button-${props.buttonText}`)} />
        </Suspense>
    )
})
MenuButton.displayName = "MenuButton"
export default connect(MenuButton)
